import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import * as selectors from '../../../accountsSelector';

import styles from '../DashboardActionPanel.module.css';
import messages from '../DashboardActionPanel.messages';
import { getCountry } from '@iwIntlProvider/CountryProvider';
import { RootState } from '@iwProvider/configureStore';
import { TProductType } from '../../../../../myAccount/dashboard/Dashboard.types';
import {
    IW_Tab,
    IW_TabGroup,
    IW_TabPanel
} from '../../../../ui/tabGroup/tabGroup';
import { TopUpDrawDown } from './TopupDrawdown';
import { InterestOnlyExtend } from './InterestOnlyExtend';

const mapStateToProps = (state: RootState) => {
    // TODO: Stop relying on the URL for the product type.
    let productType: TProductType = selectors.getProductTypeFromURL();
    if (getCountry() === 'DE' && productType === 'flexi24') {
        productType = 'credit_facility';
    }

    return {
        hasAvailableCash: selectors.hasAvailableCash(state, productType),
        interestOnlyOfferNoDrawdown:
            selectors.isInterestOnlyLoanWithNoAvailableCash(state, productType),
        interestOnlyOfferWithDrawdown:
            selectors.isInterestOnlyLoanWithAvailableCash(state, productType),
        hasOldOfferThatsStillValid: selectors.hasOldOfferThatsStillValid(
            state,
            productType
        )
    };
};

export const TopUpPanel = connect(mapStateToProps)(({
    hasAvailableCash,
    interestOnlyOfferWithDrawdown,
    interestOnlyOfferNoDrawdown,
    hasOldOfferThatsStillValid
}) => {
    if (
        interestOnlyOfferWithDrawdown &&
        !hasOldOfferThatsStillValid &&
        getCountry() === 'DE'
    ) {
        return (
            <>
                <FormattedMessage {...messages.extendInterestOnly} />{' '}
                <FormattedMessage
                    {...messages.extendInterestOnlyWithDrawdown}
                />
                <IW_TabGroup
                    className={styles.tabGroup}
                    tabs={
                        <>
                            <IW_Tab>
                                <FormattedMessage
                                    {...messages.tabInterestOnly}
                                />
                            </IW_Tab>
                            <IW_Tab disabled={!hasAvailableCash}>
                                <FormattedMessage
                                    {...messages.tabInterestOnlyWithDrawdown}
                                />
                            </IW_Tab>
                        </>
                    }
                    panels={
                        <>
                            <IW_TabPanel>
                                <InterestOnlyExtend />
                            </IW_TabPanel>
                            <IW_TabPanel>
                                <TopUpDrawDown />
                            </IW_TabPanel>
                        </>
                    }
                />
            </>
        );
    }
    if (interestOnlyOfferNoDrawdown && getCountry() === 'DE') {
        return (
            <div className={styles.interestOnlyContainer}>
                <FormattedMessage {...messages.extendInterestOnly} />
                <InterestOnlyExtend />
            </div>
        );
    }

    return <TopUpDrawDown />;
});
